import * as React from 'react'
import { useToastStoreContext } from './provider'
import { appendToastAtom } from './store'

export function useUnhandledError() {
	const store = useToastStoreContext()

	const triggerError = React.useCallback(
		(title: string, description?: string, options?: { cause?: unknown }) => {
			store.set(appendToastAtom, {
				title,
				description,
				variant: 'error',
				cause: options?.cause,
			})
		},
		[store],
	)

	return { triggerError }
}
